/* eslint-disable no-bitwise */
/* eslint-disable no-magic-numbers */
import { degreesToRadians, radiansToDegrees } from "./unitConversion";
export function getQuarterRotationStep() {
    const denominator = 2;
    return Math.PI / denominator;
}
export function getHalfRotationStep() {
    const denominator = 2;
    return getQuarterRotationStep() / denominator;
}
export function getThreeHalfRotationStep() {
    const threeHalfs = 3;
    return threeHalfs * getHalfRotationStep();
}
/** Return the number of 90-degree counter-clockwise turns the given angle represents.
 */
export function orientationToSteps(orientationInRadians) {
    const normalizedOrientationInDegrees = normalizeDegreeOrientation(radiansToDegrees(orientationInRadians));
    return Math.round(normalizedOrientationInDegrees / 90);
}
export function normalizeRadianOrientation(orientationInRadians) {
    return degreesToRadians(normalizeDegreeOrientation(radiansToDegrees(orientationInRadians)));
}
export function normalizeDegreeOrientation(orientationInDegrees) {
    let angle = orientationInDegrees % 360;
    if (angle < 0)
        angle += 360;
    return angle;
}
export function colorToSigned24Bit(s) {
    return (parseInt(s.substr(1), 16) << 8) / 256;
}
export function roundTo(n, digits) {
    return parseFloat(n.toFixed(digits));
}
//# sourceMappingURL=photonEngineHelpers.js.map